import $ from 'jquery';
import slick from 'slick-carousel';

export default () => {
  const isRtl = $('html').attr('dir')=== 'rtl' ? true : false;
  var activeLisghtbox = null;
  var activeIndex;
  $(document).delegate('.js-trigger-gallery-modal', 'click', function () {
      const slideIndex = $(this).parents('.media-slider-slide').data('index');
      const parentSlider = $(this).parents('.js-slick').data('key');
      $.each($('.js-lightbox'), function () {
          const sliderData = $(this).data('key');
      if (parentSlider == sliderData) {
        activeLisghtbox = $(this)
        $(this).data('activeSlide', slideIndex);
        activeIndex = slideIndex;
        $(this).modal('show');
      }
    });
  });

  $(document).delegate('.js-lightbox', 'shown.bs.modal', function () {
    activeLisghtbox.find('.lightbox-slider').slick({
      rtl: isRtl,
      lazyLoad: 'ondemand',
      arrows: true,
      prevArrow: $('.js-lightbox-arrow-prev'),
      nextArrow: $('.js-lightbox-arrow-next'),
      adaptiveHeight: true,
      infinite: true,
      slidesToshow: 1,
      initialSlide: activeIndex,
      fade: true,
      cssEase: 'linear'
    });
    $(window).on('keydown', function (e) {
      switch (e.keyCode) {
        case 37: if($('.js-lightbox ').hasClass('show')){$('.lightbox-slider').slick('prev')}
        case 39: if($('.js-lightbox ').hasClass('show')){$('.lightbox-slider').slick('next')}
        case 32: e.preventDefault(); break; // Space
        default: break; // do not block other keys
      }
    });

    activeLisghtbox.find('.lightbox-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			var current = activeLisghtbox.find('.lightbox-slider').find('.slick-current');
			var video;
				if(current.find('.lightbox-slide-video').length){
					video = current.find('.lightbox-slide-video').find('.js-lighbox-video');
						video[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
				}

    });
  });
  $(document).delegate('.js-lightbox', 'hidden.bs.modal', function (e) {
    const lighboxSlider = $(this).find('.lightbox-slider');
    lighboxSlider.slick('unslick');
  });
};